import * as React from "react";
import {memo} from "react";
import {usePatientStatusBannerStyle} from "./patient-status-banner.style";
import {IPatientStatusSource, PatientStatus, resolvePatientStatusId, resolvePatientStatusName} from "../patient-status.pipe";

export interface IPatientStatusBannerProps {
    readonly patient: IPatientStatusSource | null | undefined;
}

export const PatientStatusBanner = memo((props: IPatientStatusBannerProps) => {
    const classes = usePatientStatusBannerStyle();
    const status = resolvePatientStatusId(props.patient);

    if (!status) {
        return null;
    }

    const statusClasses: Partial<Record<number, string>> = {
        [PatientStatus.Enrolled]: classes.enrolled,
        [PatientStatus.Active]: classes.active,
        [PatientStatus.Paused]: classes.paused,
        [PatientStatus.Discontinued]: classes.discontinued,
    };

    return (
        <div
            id="patient-status-banner"
            className={`${classes.banner} ${statusClasses[status] ?? ''}`}
        >
            {resolvePatientStatusName(props.patient)}
        </div>
    );
});
